import React, { Component } from 'react';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
const styles = theme => ({
    light: {
        backgroundColor: theme.palette.border.light
    },
    root:{
        backgroundColor: theme.palette.border.primary,
        marginLeft:theme.spacing(13)
    },
    fullWidth:{
        marginLeft:0
    }
});

class DividerCustom extends Component {
    render() {
        const {classes,className,color,fullWidth} = this.props;
        const dividerClasses = classNames({
            [classes.root]: true,
            [classes[color]]: color,
            [classes.fullWidth]: fullWidth,
            [className]: className
        });
        return (
            <Divider variant="inset" className={dividerClasses} />
        );
    }
}
export default withStyles(styles)(DividerCustom);
